import { Injectable, signal } from '@angular/core';

/**
 * Local UI preference: when enabled, hidden/unbuilt Admin nav items
 * appear in the sidebar. Persists in localStorage; not a product feature flag.
 */
@Injectable({ providedIn: 'root' })
export class DemoModeService {
  private static readonly storageKey = 'ain.admin.demoMode';
  private readonly enabledState = signal(readStoredFlag(DemoModeService.storageKey));
  readonly enabled = this.enabledState.asReadonly();

  toggle(): void {
    this.setEnabled(!this.enabledState());
  }

  setEnabled(value: boolean): void {
    this.enabledState.set(value);
    try {
      globalThis.localStorage?.setItem(DemoModeService.storageKey, value ? '1' : '0');
    } catch {
      // Ignore localStorage write failures.
    }
  }
}

function readStoredFlag(key: string): boolean {
  try {
    return globalThis.localStorage?.getItem(key) === '1';
  } catch {
    return false;
  }
}
